import { motion } from "framer-motion";
import { Network, Building2, FolderCheck, Handshake, TrendingUp } from "lucide-react";

const REASONS = [
  {
    icon: Network,
    title: "ONE ECOSYSTEM",
    desc: "Multiple business setup requirements coordinated through one platform.",
    accent: "#FF8800",
  },
  {
    icon: Building2,
    title: "BUSINESS-FIRST APPROACH",
    desc: "Understand the business before identifying requirements.",
    accent: "#00B0FF",
  },
  {
    icon: FolderCheck,
    title: "DOCUMENT SUPPORT",
    desc: "Help entrepreneurs organize the information and documentation needed.",
    accent: "#00E676",
  },
  {
    icon: Handshake,
    title: "PROCESS COORDINATION",
    desc: "Coordinate with appropriate professionals and authorities where required.",
    accent: "#FF8800",
  },
  {
    icon: TrendingUp,
    title: "GROWTH READY",
    desc: "Build the compliance foundation needed for the next stage of the business.",
    accent: "#00B0FF",
  },
];

export function WhyLaunchLab() {
  return (
    <section data-testid="why-launchlab-section" className="relative py-20 sm:py-28 lg:py-32">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl mb-14"
        >
          <p className="font-mono-tech text-xs tracking-[0.35em] text-[#00B0FF] uppercase mb-4">Why LaunchLab</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white" data-testid="why-launchlab-headline">
            BUILT AROUND <span className="text-gradient-saffron">YOUR BUSINESS</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5" data-testid="why-launchlab-cards">
          {REASONS.map((r, i) => (
            <motion.div
              key={r.title}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.55, delay: i * 0.08 }}
              className="card-beam group relative rounded-2xl border border-slate-800 bg-[#0D111D]/90 p-6 transition-all duration-300 hover:-translate-y-1.5"
              data-testid={`why-card-${i}`}
            >
              <div
                className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none rounded-2xl"
                style={{ boxShadow: `inset 0 0 0 1px ${r.accent}55, 0 0 30px ${r.accent}15` }}
              />
              <div
                className="w-11 h-11 rounded-xl flex items-center justify-center mb-5"
                style={{ background: `${r.accent}14`, border: `1px solid ${r.accent}33` }}
              >
                <r.icon className="w-5 h-5" style={{ color: r.accent }} strokeWidth={1.8} />
              </div>
              <h3 className="font-display text-base font-bold tracking-wide text-white">{r.title}</h3>
              <p className="mt-2.5 text-sm text-slate-400 leading-relaxed">{r.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
